export enum EventType {
  SICKNESS = 'Sickness',
  MATERNITY_LEAVE = 'Maternity leave',
  ANNUAL_LEAVE = 'Annual leave',
  REQUEST_OFF = 'Request off'
}
